import React, { useState, useEffect } from "react"
import { enumvaluetranslations } from "../../../utils/enumvaluetranslations"
import { DateSelect, StateSelect, useDateFilter, useFilterTransactions, useSearchFilter, useSelectFilter } from "../../../utils/filterutils"
import { useExpandRows, useSortTransactions } from "../../../utils/tablehooks"
import { IncomingTransactionsHeaderView, IncomingTransactionsTableView } from "./IncomingTransactionsView"


const IncomingTransactionsTableContainer = ({ children, incomingTransactions, handleShowConfirmationModal, newCorrections, corrections, addNewCorrectionForArticleType, openCorrectionLine, getCorrectionInputFields, getNewCorrectionValues }) => {

    const [filterable, setFilterable] = useState(false)
    const [filteredIncomingTransactions, setFilteredIncomingTransactions] = useState([])
    const [sortedIncomingTransactions, setSortedIncomingTransactions] = useState([])
    const [filterArticles, setFilterArticles] = useState(false)
    const toggleFilterArticles = () => {
        setFilterArticles(!filterArticles)
    }

    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { sortTransactions } = useSortTransactions(incomingTransactions, setSortedIncomingTransactions)
    const { filterTransactionsBySearchInput, filterTransactionsAndArticlesBySearchInput, filterTransactionsByDateInput, filterTransactionsBySelectInput } = useFilterTransactions()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    /**
     * UseEffect hook resets filtered transactions every time the original data changes
    */
    useEffect(() => {
        setFilteredIncomingTransactions([...incomingTransactions])
    }, [incomingTransactions])

    const takeSortedTransactions = () => {
        //Maybe this shouldn't be done in general, as there should be another option to deep clone an object!
        let deepCopy = JSON.parse(JSON.stringify(sortedIncomingTransactions))
        return deepCopy
    }

    /**
     * UseEffect hook that filters the transactions.
     * Executed every time one of the filter/selection inputs changes.
    */
    useEffect(() => {
        let filteredTransactions = filterArticles ? filterTransactionsAndArticlesBySearchInput(takeSortedTransactions(), searchInput) : filterTransactionsBySearchInput(sortedIncomingTransactions, searchInput)
        filteredTransactions = filterTransactionsByDateInput(filteredTransactions, dateSelect)
        filteredTransactions = filterTransactionsBySelectInput(filteredTransactions, statusSelect)

        setFilteredIncomingTransactions(filteredTransactions)
    }, [searchInput, dateSelect, statusSelect, sortedIncomingTransactions, filterArticles])

    /**
     * Toggles the filterable value; indicates if filter menu is opened
    */
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    /**
     * Sorts the transactions passed into "useSortTransactions" hook after field value
     * @param {any} e click event
     * @param {string} field property to sort after
     */
    const handleSortTransactions = (e, field) => {
        e.preventDefault()
        sortTransactions(field)
    }

    return (
        <>
            <IncomingTransactionsHeaderView handleSearchInput={handleSearchInput} setFilterbar={setFilterbar} filteredIncomingTransactions={filteredIncomingTransactions} />
            <IncomingTransactionsTableView filteredIncomingTransactions={filteredIncomingTransactions} DateSelect={DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)} StateSelect={StateSelect([...new Set(incomingTransactions.map(x => enumvaluetranslations(x.State)))], handleStatusSelectChange, statusSelect)}
                filterable={filterable} handleShowConfirmationModal={handleShowConfirmationModal} getIsExpandedRow={getIsExpandedRow} expandRow={expandRow} handleSortTransactions={handleSortTransactions}
                newCorrections={newCorrections} corrections={corrections} addNewCorrectionForArticleType={addNewCorrectionForArticleType} openCorrectionLine={openCorrectionLine} getCorrectionInputFields={getCorrectionInputFields} getNewCorrectionValues={getNewCorrectionValues} />
        </>
    )
}

export { IncomingTransactionsTableContainer }